<template>
  <div class="table-container">
    <TableCommon
      title="编辑数据"
      :custome-config="() => vxeShowCustom('xTableEdit')"
    >
      <template #button>
        <table-button v-if="false" name="add" tip="新建" />
      </template>
      <vxe-grid
        ref="xTableEdit"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="300"
        max-height="500"
        align="center"
        size="mini"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions.columns"
        :data="gridOptions.data"
      >
        <template #parameter3="{ row }">
          <el-input v-model.trim="row.parameter3" size="mini" disabled />
        </template>
        <template #product_name="{ row }">
          <el-input v-model.trim="row.product_name" size="mini" disabled />
        </template>
        <template #parameter4="{ row }">
          <el-input
            v-model.trim="row.parameter4"
            placeholder="请输入最小订单件数"
            size="mini"
            type="number"
            min="0"
          />
        </template>
        <template #parameter5="{ row }">
          <el-input
            v-model.trim="row.parameter5"
            placeholder="请输入最大订单件数"
            size="mini"
            type="number"
            min="0"
          />
        </template>
        <template #active="{ row }">
          <el-tag size="mini" :type="row.active === 'X' ? 'success' : 'info'">
            {{ row.active === 'X' ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </vxe-grid>
    </TableCommon>
  </div>
</template>

<script>
export default {
  name: 'GroupPurchaseEdit',
  props: {
    editRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      gridOptions: {
        data: [],
        columns: [
          { type: 'seq', title: '序号', width: 60 },
          { field: 'parameter3', title: '产品编码', width: 160, slots: { default: 'parameter3' } },
          { field: 'product_name', title: '产品名称', minWidth: 200, slots: { default: 'product_name' } },
          { field: 'parameter4', title: '最小订单件数', width: 180, slots: { default: 'parameter4' } },
          { field: 'parameter5', title: '最大订单件数', width: 180, slots: { default: 'parameter5' } },
          { field: 'active', title: '状态', width: 140, slots: { default: 'active' } }
        ]
      }
    }
  },
  watch: {
    editRows: {
      immediate: true,
      deep: true,
      handler(val) {
        this.gridOptions.data = (val || []).map(item => ({
          ...item,
          parameter4: item.parameter4 || '',
          parameter5: item.parameter5 || '',
          active: item.active || ''
        }))
      }
    }
  },
  methods: {
    validRows() {
      if (!this.gridOptions.data.length) {
        this.$message.warning('请选择需要修改的数据')
        return null
      }
      const integerReg = /^\d+$/
      for (const row of this.gridOptions.data) {
        if (row.parameter4 === '' || row.parameter5 === '') {
          this.$message.warning('请填写最小/最大订单件数')
          return null
        }
        if (!integerReg.test(row.parameter4) || !integerReg.test(row.parameter5)) {
          this.$message.warning('订单件数需为非负整数')
          return null
        }
        if (Number(row.parameter5) < Number(row.parameter4)) {
          this.$message.warning('最大订单件数需大于等于最小订单件数')
          return null
        }
      }
      return this.gridOptions.data.map(row => ({
        ...row,
        parameter4: `${row.parameter4}`,
        parameter5: `${row.parameter5}`
      }))
    },
    reset() {
      this.gridOptions.data = []
    }
  }
}
</script>

<style scoped>
.table-container {
  max-height: 480px;
}
</style>




// WEBPACK FOOTER //
// src/views/product-manage/components/GroupPurchaseEdit.vue